module.exports = __webpack_public_path__ + "static/media/town_scene-welsh.e0d27e81.svg";